import { LoadingOutlined } from "@ant-design/icons";
import { Result } from "antd";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const LogoutRedirectPage = () => {
  const [searchParams] = useSearchParams();
  const param = searchParams.get("returnTo");

  useEffect(() => {
    (window as any).location.href = param;
  }, [param]);

  return <Result icon={<LoadingOutlined />} title="Redirection to previous page..." />;
};
